import {
  LiikkuvaWifiOfferCode,
  LiikkuvaWifiProductCode,
  LiikkuvaWifiSalesProductOfferCode,
  LiikkuvaWifiSalesProductOnlineModel,
} from '../../../common/constants/subscriptionConstants';
import {
  FiveGMobileBroadbandOfferCode,
  FiveGMobileBroadbandProductCode,
  SubscriptionCardType,
} from '../../../common/enums';
import {
  additionalServicesMsg,
  euDataMsg,
  finlandNordicsAndBalticsMsg2,
  outsideEuMsg,
  recommendationUsersDevicesMsg,
  selectMsg,
  t,
  unlimitedMsg,
  uploadSpeedMsg,
} from '../../../common/i18n';
import { SUBSCRIPTION_CHANGE_SERVICE_FEE } from './LaitenettiSubscriptionCardContent';
import {
  getLiikkuvaWifiService,
  getManagedServiceService,
  getMobiiliturvaService,
  getReissaajaService,
  getReissunetti1Service,
  getReissunetti2Service,
} from './ServiceContentCreator';
import { productVariables } from './variables';
import type { MobileBroadbandSubCardProps } from '../../SubscriptionCard/SubscriptionCard';

const getMobileRouterPackageContents = () => ({
  title: t.DRG7('Mobile router package contents'),
  items: [
    t.Z6R6('Mobile router ZTE MU5120'),
    t.XHN1('Power supply'),
    t.P9L6('USB cable'),
    t.RJR0('Instruction manual and quick start guide'),
    t.HYX0('2.4" LCD touch screen'),
    t.LAC9('10000mAh battery'),
    t.DB9E('33W fast charging'),
  ],
});

const getDeviceMaintenance = () => ({
  title: t.AFJM('Device maintenance'),
  items: [
    t.CB08(
      'When you order the service, you get the subscription and device delivered to you quickly and easily as a ready-to-use package'
    ),
    t.J0U1('Automatic updates ensure that using the service is safe and stress-free'),
    t.YI0M(`In fault situations, you'll receive a replacement device by mail within 1 or 2 business days`),
  ],
});

const getYritysdataSubscriptionCards = (inPublicStore?: boolean): MobileBroadbandSubCardProps[] => [
  {
    bullets: [
      t.SDTT('Superfast business use'),
      t.SDTU('Video conferences and 8K movies'),
      t.SDTV('All internet users and devices'),
    ],
    description: t.SDTW('For super-fast business use'),
    cardName: '1000m',
    mainHeader: 'Yritysdata 1000 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_5G_PLUS_1000_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_1000_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_1000_M].uploadSpeed?.(),
      },
    ],
    services: [getMobiiliturvaService(true, inPublicStore), getReissunetti2Service(true)],
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        {
          label: euDataMsg,
          value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_1000_M].euFupLimit?.() || '',
        },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 2${t.C4YQ('GB')}`,
        },
      ],
    },
    monthlyPrice: 4499,
    oneTimePrice: 899,
  },
  {
    bullets: [
      t.SDTP('Fast business use'),
      t.SDTQ('Video conferences and 4K movies'),
      t.SDTL(recommendationUsersDevicesMsg, '4+', '15+'),
    ],
    description: t.SDTS('For fast business use'),
    cardName: '600m',
    mainHeader: 'Yritysdata 600 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_5G_PLUS_600_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_600_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_600_M].uploadSpeed?.(),
      },
    ],
    services: [getMobiiliturvaService(true, inPublicStore), getReissunetti1Service(true)],
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        {
          label: euDataMsg,
          value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_600_M].euFupLimit?.() || '',
        },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 1-1,5 ${t.C4YQ('GB')}`,
        },
      ],
    },
    monthlyPrice: 3999,
    oneTimePrice: 899,
  },
  {
    bullets: [
      t.SDTN('Active work'),
      t.SDTO('Video meetings and watching shows'),
      t.SDTL(recommendationUsersDevicesMsg, '3-4', '10-15'),
    ],
    description: t.SDTR('For active internet use'),
    cardName: '300m',
    mainHeader: 'Yritysdata 300 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_5G_PLUS_300_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_300_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_300_M].uploadSpeed?.(),
      },
    ],
    services: [getReissunetti1Service(true), getMobiiliturvaService(false, inPublicStore)],
    recommended: true,
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        {
          label: euDataMsg,
          value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_300_M].euFupLimit?.() || '',
        },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 1-1,5 ${t.C4YQ('GB')}`,
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
    monthlyPrice: 3499,
    oneTimePrice: 899,
  },
  {
    cardName: '100m',
    mainHeader: 'Yritysdata 100 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_5G_PLUS_100_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_100_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_100_M].uploadSpeed?.(),
      },
    ],
    bullets: [
      t.SDTJ('Smooth everyday life and work'),
      t.SDTK('Meetings and movies'),
      t.SDTL(recommendationUsersDevicesMsg, '1-2', '1-4'),
    ],
    services: [getReissaajaService(true), getMobiiliturvaService(false, inPublicStore)],
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        {
          label: euDataMsg,
          value: productVariables[FiveGMobileBroadbandProductCode.MBB_5G_PLUS_100_M].euFupLimit?.() || '',
        },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 1-1,5 ${t.C4YQ('GB')}`,
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
    description: t.SDTM('Smooth everyday use'),
    monthlyPrice: 2999,
    oneTimePrice: 899,
  },
  {
    cardName: '50m',
    mainHeader: 'Yritysdata 50 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_50_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_50_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_50_M].uploadSpeed?.(),
      },
    ],
    bullets: [
      t.SDTJ('Smooth everyday life and work'),
      t.SDTK('Meetings and movies'),
      t.SDTL(recommendationUsersDevicesMsg, '1-2', '1-4'),
    ],
    services: [getReissaajaService(true), getMobiiliturvaService(false, inPublicStore)],
    description: t.KVG8('Video calls, cloud services use and light remote working'),
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        { label: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_50_M].euFupLimit?.() || '' },
        {
          label: t.DTQ6(outsideEuMsg),
          value: 'Reissaaja',
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
    monthlyPrice: 2299,
    oneTimePrice: 899,
  },
  {
    cardName: '10m',
    mainHeader: 'Yritysdata 10 M',
    selectedOffer: FiveGMobileBroadbandOfferCode.MBB_10_M,
    specifications: [
      { name: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_10_M].euFupLimit?.() },
      {
        name: t.CQQ7(uploadSpeedMsg),
        value: productVariables[FiveGMobileBroadbandProductCode.MBB_10_M].uploadSpeed?.(),
      },
    ],
    bullets: [
      t.SDTJ('Smooth everyday life and work'),
      t.SDTK('Meetings and movies'),
      t.SDTL(recommendationUsersDevicesMsg, '1-2', '1-4'),
    ],
    services: [getReissaajaService(true), getMobiiliturvaService(false, inPublicStore)],
    description: t.KVG9('Light internet use, reading emails, sending messages'),
    modalContent: {
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        { label: euDataMsg, value: productVariables[FiveGMobileBroadbandProductCode.MBB_10_M].euFupLimit?.() || '' },
        {
          label: t.DTQ6(outsideEuMsg),
          value: 'Reissaaja',
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
    monthlyPrice: 1499,
    oneTimePrice: 899,
  },
];

const getLiikkuvaWifiCardContent = (): MobileBroadbandSubCardProps[] => [
  {
    bullets: [
      t.SDTT('Superfast business use'),
      t.SDTU('Video conferences and 8K movies'),
      t.SDTV('All internet users and devices'),
    ],
    description: t.SDTW('For super-fast business use'),
    cardName: 'wifi1000m',
    mainHeader: 'Liikkuva Wifi 1000 M',
    publicPage: {
      offerCode: LiikkuvaWifiSalesProductOfferCode.LIIKKUVA_WIFI_1000M,
      onlineModelCode: LiikkuvaWifiSalesProductOnlineModel.LIIKKUVA_WIFI_1000M,
    },
    selectedOffer: LiikkuvaWifiOfferCode.MBB_1000_M,
    specifications: [
      { name: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_1000_M].euFupLimit?.() },
      { name: t.CQQ7(uploadSpeedMsg), value: productVariables[LiikkuvaWifiProductCode.MBB_1000_M].uploadSpeed?.() },
    ],
    services: [
      getLiikkuvaWifiService(true),
      getManagedServiceService(true),
      getReissunetti2Service(true),
      getMobiiliturvaService(false),
    ],
    monthlyPrice: 7999,
    oneTimePrice: 2319,
    modalContent: {
      devicePackageContents: getMobileRouterPackageContents(),
      deviceMaintenance: getDeviceMaintenance(),
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        { label: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_1000_M].euFupLimit?.() || '' },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 2${t.C4YQ('GB')}`,
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
  },
  {
    bullets: [
      t.SDTP('Fast business use'),
      t.SDTQ('Video conferences and 4K movies'),
      t.SDTL(recommendationUsersDevicesMsg, '4+', '15+'),
    ],
    description: t.SDTS('For fast business use'),
    cardName: 'wifi600m',
    mainHeader: 'Liikkuva Wifi 600 M',
    publicPage: {
      offerCode: LiikkuvaWifiSalesProductOfferCode.LIIKKUVA_WIFI_600M,
      onlineModelCode: LiikkuvaWifiSalesProductOnlineModel.LIIKKUVA_WIFI_600M,
    },
    selectedOffer: LiikkuvaWifiOfferCode.MBB_600_M,
    specifications: [
      { name: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_600_M].euFupLimit?.() },
      { name: t.CQQ7(uploadSpeedMsg), value: productVariables[LiikkuvaWifiProductCode.MBB_600_M].uploadSpeed?.() },
    ],
    services: [
      getLiikkuvaWifiService(true),
      getManagedServiceService(true),
      getReissunetti1Service(true),
      getMobiiliturvaService(false),
    ],
    monthlyPrice: 6999,
    oneTimePrice: 2319,
    recommended: true,
    modalContent: {
      devicePackageContents: getMobileRouterPackageContents(),
      deviceMaintenance: getDeviceMaintenance(),
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        { label: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_600_M].euFupLimit?.() || '' },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 1-1,5 ${t.C4YQ('GB')}`,
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
  },
  {
    bullets: [
      t.SDTN('Active work'),
      t.SDTO('Video meetings and watching shows'),
      t.SDTL(recommendationUsersDevicesMsg, '3-4', '10-15'),
    ],
    description: t.SDTR('For active internet use'),
    cardName: 'wifi300m',
    mainHeader: 'Liikkuva Wifi 300 M',
    publicPage: {
      offerCode: LiikkuvaWifiSalesProductOfferCode.LIIKKUVA_WIFI_300M,
      onlineModelCode: LiikkuvaWifiSalesProductOnlineModel.LIIKKUVA_WIFI_300M,
    },
    selectedOffer: LiikkuvaWifiOfferCode.MBB_300_M,
    specifications: [
      { name: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_300_M].euFupLimit?.() },
      { name: t.CQQ7(uploadSpeedMsg), value: productVariables[LiikkuvaWifiProductCode.MBB_300_M].uploadSpeed?.() },
    ],
    services: [
      getLiikkuvaWifiService(true),
      getManagedServiceService(true),
      getReissunetti1Service(true),
      getMobiiliturvaService(false),
    ],
    monthlyPrice: 5999,
    oneTimePrice: 2319,
    modalContent: {
      devicePackageContents: getMobileRouterPackageContents(),
      deviceMaintenance: getDeviceMaintenance(),
      networkSpecs: [
        { label: t.UMWH('Supported networks'), value: '4G, 5G, 5G+' },
        { label: t.OMY8(finlandNordicsAndBalticsMsg2), value: t.MVTD(unlimitedMsg) },
        { label: euDataMsg, value: productVariables[LiikkuvaWifiProductCode.MBB_300_M].euFupLimit?.() || '' },
        {
          label: t.DTQ6(outsideEuMsg),
          value: `Reissunetti 1-1,5 ${t.C4YQ('GB')}`,
        },
      ],
      additionalServices: {
        title: t.LXSR(additionalServicesMsg),
        items: ['Elisa Mobiiliturva'],
      },
    },
  },
];

export const getMobileBroadbandSubscriptionCardContents = (
  inPublicStore?: boolean,
  isChangeOffer?: boolean
): MobileBroadbandSubCardProps[] => {
  const liikkuvaWifiCardContents = getLiikkuvaWifiCardContent().map(cardContent => cardContent);
  const yritysdataCardContents = getYritysdataSubscriptionCards(inPublicStore).map(cardContent => cardContent);
  return [...liikkuvaWifiCardContents, ...yritysdataCardContents].map(cardContent => ({
    ...cardContent,
    buttonText: t.QRYV(selectMsg),
    // Public side doesn't do updates on subs
    serviceFee: isChangeOffer ? SUBSCRIPTION_CHANGE_SERVICE_FEE : undefined,
    cardType: SubscriptionCardType.MOBILE_BROADBAND,
  }));
};
